import { dev_baseUrl } from "../../../utils/var";

export const CheckoutSuccess = async (sessionID) => {  
    try {
      const response = await fetch(`${dev_baseUrl}/Subscription/success?sessionId=${sessionID}`, {
        method: 'GET',
        headers: {          
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      return data;
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
};
